import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ILocation } from './models/iLocation';
import { ICoordinates } from './models/iCoordinates';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  constructor() {}

  private locations: BehaviorSubject<ILocation[]> = new BehaviorSubject<
    ILocation[]
  >([]);
  private selectedLocation: BehaviorSubject<ILocation> = new BehaviorSubject<
    ILocation
  >(null);
  private coordiantes: BehaviorSubject<ICoordinates> = new BehaviorSubject<
    ICoordinates
  >(null);
  private locationVisible: BehaviorSubject<Boolean> = new BehaviorSubject<
    Boolean
  >(false);
  private locationEditable: BehaviorSubject<Boolean> = new BehaviorSubject<
    Boolean
  >(false);

  public editBtnClass = '';

  public getLocations(): BehaviorSubject<ILocation[]> {
    return this.locations;
  }

  public Locations(): ILocation[] {
    return this.locations.getValue();
  }

  public setLocations(data: ILocation[]) {
    this.locations.next(data);
  }

  public addLocation(data: ILocation) {
    const locs = this.Locations();
    locs.push(data);
    this.setLocations(locs);
  }

  public removeLocation(data: ILocation) {
    let locs = this.Locations();

    locs = locs.filter(v => v.Title !== data.Title);

    this.setLocations(locs);
  }

  public setLocation(data: ILocation) {
    this.selectedLocation.next(data);
    if (data.Coordinates) {
      this.coordiantes.next(data.Coordinates);
    }
  }

  public resetLocation() {
    this.selectedLocation.next(null);
    this.coordiantes.next({ Latitude: null, Longitude: null });
  }

  public getLocation(): BehaviorSubject<ILocation> {
    return this.selectedLocation;
  }

  public Location(): ILocation {
    return this.selectedLocation.getValue();
  }

  public setLocationEditability(value?: Boolean) {
    this.locationEditable.next(!!value ? value : false);
  }

  getLocationEditability(): BehaviorSubject<Boolean> {
    return this.locationEditable;
  }

  public isLocationEditable(): Boolean {
    return this.locationEditable.getValue();
  }

  public isLocationVisible(): Boolean {
    return this.locationVisible.getValue();
  }

  public getLocationVisibility(): BehaviorSubject<Boolean> {
    return this.locationVisible;
  }

  public setlocationVisibility(value?: Boolean) {
    if (!value) {
      this.locationVisible.next(!this.locationVisible.getValue());
    } else {
      this.locationVisible.next(value as Boolean);
    }
  }

  public setCoordinates(coordiantes: ICoordinates) {
    this.coordiantes.next(coordiantes);
  }

  public getCoordinates(): BehaviorSubject<ICoordinates> {
    return this.coordiantes;
  }

  public Coordinates(): ICoordinates {
    return this.coordiantes.getValue();
  }
}
